/**
 * This component is used to wrap a step in a multi step dialog.
 * Helper component that combines the more menu, title, content and actions components.
 */
import DialogActions, { Props as DialogActionsProps } from './DialogActions';
import DialogMoreMenu, { Props as DialogMoreMenuProps } from './DialogMoreMenu';
import DialogTitle, { Props as DialogTitleProps } from './DialogTitle';
import { DialogContent } from '@mui/material';
import { FC, ReactNode } from 'react';

type Props = DialogMoreMenuProps & DialogTitleProps & DialogActionsProps & { children?: ReactNode };

const DialogStep: FC<Props> = ({ children, ...props }) => {
  return (
    <>
      <DialogMoreMenu {...props} />
      <DialogContent
        // eslint-disable-next-line no-restricted-syntax
        sx={{
          flexGrow: 0,
        }}
      >
        <DialogTitle {...props} />
        {children}
      </DialogContent>
      <DialogActions {...props} />
    </>
  );
};

export default DialogStep;
